<template>
  <router-view />
</template>

<script>
export default {
  name: 'BlankLayoutPage'
}
</script>

<style scoped>

</style>